var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/no-multi-comp */
import React from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { t, Translate } from "../../../../../I18N";
import { Button, Pill } from "../../../../Components/UI";



const TemplateHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Templates");

const ThesaurusLabel = ({ cell }) => {
  const translated = t(
    cell.row.original._id,
    cell.row.original.name,
    cell.row.original.name,
    false
  );
  const hidden = translated === cell.row.original.name;
  return (/*#__PURE__*/
    _jsx("div", { className: "flex items-center" }, void 0, /*#__PURE__*/
    _jsx("span", { className: "text-indigo-700" }, void 0, cell.row.original.name),
    hidden && /*#__PURE__*/
    _jsx("div", { className: "has-[span:not(.active)]:hidden h-full p-1 ml-2 border-2 border-gray-400 border-solid rounded-lg border-y-0" }, void 0, /*#__PURE__*/
    _jsx(Translate, { context: cell.row.original._id }, void 0, cell.row.original.name)
    ),

    !hidden && /*#__PURE__*/
    _jsx("div", { className: "h-full p-1 ml-2 border-2 border-gray-400 border-solid rounded-lg border-y-0 " }, void 0, /*#__PURE__*/
    _jsx(Translate, { context: cell.row.original._id }, void 0, cell.row.original.name)
    )

    ));

};

const ActionHeader = () => /*#__PURE__*/_jsx(Translate, { className: "sr-only" }, void 0, "Action");

const ThesaurusValueLabel = ({ getValue, cell }) => {
  const { thesaurus } = cell.getContext().column.columnDef.meta.data;
  const label = getValue();
  const translated = (thesaurus === null || thesaurus === void 0 ? void 0 : thesaurus._id) && t(thesaurus._id, label, label, false);
  const hidden = translated === label;
  return (/*#__PURE__*/
    _jsx("div", { className: "flex items-center gap-2" }, void 0, /*#__PURE__*/
    _jsx("span", { className: "text-indigo-700" }, void 0, label),
    thesaurus !== undefined && hidden && /*#__PURE__*/
    _jsx("div", { className: "has-[span:not(.active)]:hidden h-full p-1 ml-2 border-2 border-gray-400 border-solid rounded-lg border-y-0" }, void 0, /*#__PURE__*/
    _jsx(Translate, { context: thesaurus._id, className: "text-gray-700 " }, void 0,
    label
    )
    ),

    thesaurus !== undefined && !hidden && /*#__PURE__*/
    _jsx("div", { className: "h-full p-1 ml-2 border-2 border-gray-400 border-solid rounded-lg border-y-0" }, void 0, /*#__PURE__*/
    _jsx(Translate, { context: thesaurus._id, className: "text-gray-700 " }, void 0,
    label
    )
    )

    ));

};

const templatesCells = ({ cell }) => {var _cell$getValue;return (/*#__PURE__*/
    _jsx("div", { className: "flex flex-wrap gap-2" }, void 0, (_cell$getValue =
    cell.getValue()) === null || _cell$getValue === void 0 ? void 0 : _cell$getValue.map((template) => /*#__PURE__*/
    _jsx("div", {}, cell.id + template._id, /*#__PURE__*/
    _jsx(Pill, { color: "gray", className: "whitespace-nowrap" }, void 0, /*#__PURE__*/
    _jsx(Translate, { context: template._id }, void 0, template.name)
    )
    )
    )
    ));};


const EditButton = ({
  cell,
  column
}) => /*#__PURE__*/
_jsx(Button, {
  styling: "light",
  onClick: () => {var _column$columnDef$met, _column$columnDef$met2;return (_column$columnDef$met = column.columnDef.meta) === null || _column$columnDef$met === void 0 ? void 0 : (_column$columnDef$met2 = _column$columnDef$met.action) === null || _column$columnDef$met2 === void 0 ? void 0 : _column$columnDef$met2.call(_column$columnDef$met, cell.row);},
  className: "leading-4" }, void 0, /*#__PURE__*/

_jsx(Translate, {}, void 0, "Edit")
);


const LabelHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Label");


















const columnHelperThesaurus = createColumnHelper();
const columnsThesaurus = (actions, thesaurus) => [
columnHelperThesaurus.accessor('label', {
  id: 'label',
  header: LabelHeader,
  cell: ThesaurusValueLabel,
  meta: { headerClassName: 'w-11/12', data: { thesaurus } }
}),
columnHelperThesaurus.accessor('id', {
  header: ActionHeader,
  cell: EditButton,
  enableSorting: false,
  meta: {
    action: actions.edit
  }
})];


const columnHelperThesauri = createColumnHelper();
const columnsThesauri = ({ edit }) => [
columnHelperThesauri.accessor('name', {
  id: 'name',
  header: LabelHeader,
  cell: ThesaurusLabel,
  meta: { headerClassName: 'w-6/12 font-medium' }
}),
columnHelperThesauri.accessor('templates', {
  header: TemplateHeader,
  cell: templatesCells,
  enableSorting: false,
  meta: { headerClassName: 'w-6/12' }
}),
columnHelperThesauri.accessor('_id', {
  header: ActionHeader,
  cell: EditButton,
  enableSorting: false,
  meta: { action: edit }
})];


export {
  ThesaurusLabel,
  LabelHeader,
  EditButton,
  ThesaurusValueLabel,
  ActionHeader,
  templatesCells,
  TemplateHeader,
  columnsThesaurus,
  columnsThesauri };